import { TokenLogout } from 'API/Logout/logout';
import axios from 'axios';

const url = process.env.REACT_APP_APPROVAL_URL;
const url2 = process.env.REACT_APP_POST_APPROVAL_URL;

export const GetAllRequest = async (Page, setData, setIsLoading, setTotalCount) => {
  let usertype = sessionStorage.getItem('UserType');
  try {
    setIsLoading(true);
    await axios
      .post(
        `${url2}/ds/${usertype}/pending/list?page=${Page}`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        setIsLoading(false);
        console.log(res.data.ds_list);

        setData(res.data.ds_list);
        setTotalCount(res.data);
      })
      .catch((err) => {
        // console.log(err);
        setData(null);
        setIsLoading(false);
        TokenLogout(err);
      });
  } catch (error) {
    // console.log(error);
    setData(null);
    setIsLoading(false);
    TokenLogout(error);
  }
};

export const GetNonFiPendingList = async (Page, setData, setIsLoading, setTotalCount) => {
  // let usertype = sessionStorage.getItem('UserType');
  try {
    setIsLoading(true);
    await axios
      .post(
        `${url2}/ds/non_fi/pending/list?page=${Page}`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        setIsLoading(false);
        console.log(res.data.ds_data);

        setData(res.data.ds_data);
        setTotalCount(res.data);
      })
      .catch((err) => {
        // console.log(err);
        setData(null);
        setIsLoading(false);
        TokenLogout(err);
      });
  } catch (error) {
    // console.log(error);
    setData(null);
    setIsLoading(false);
    TokenLogout(error);
  }
};

export const GetRequestByStatus = async (Page, status, setData, setIsLoading) => {
  let usertype = sessionStorage.getItem('UserType');
  try {
    setIsLoading(true);
    await axios
      .post(
        `${url2}/ds/${usertype}/updated/list`,
        { gm_ds_status: status },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          },
          params: {
            page: Page,
            limit: 10
          }
        }
      )
      .then((res) => {
        setIsLoading(false);
        setData(res.data);
      })
      .catch((err) => {
        // console.log(err);
        setData(null);
        setIsLoading(false);
        TokenLogout(err);
      });
  } catch (error) {
    // console.log(error);
    setData(null);
    setIsLoading(false);
    TokenLogout(error);
  }
};

export const GetNonFiByStatus = async (Page, limit, status, setData, setIsLoading) => {
  // let usertype = sessionStorage.getItem('UserType');
  try {
    setIsLoading(true);
    await axios
      .post(
        `${url2}/ds/non_fi/updated/list`,
        { ds_status: status },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          },
          params: {
            page: Page,
            limit: limit
          }
        }
      )
      .then((res) => {
        setIsLoading(false);
        setData(res.data);
      })
      .catch((err) => {
        // console.log(err);
        setData(null);
        setIsLoading(false);
        TokenLogout(err);
      });
  } catch (error) {
    // console.log(error);
    setData(null);
    setIsLoading(false);
    TokenLogout(error);
  }
};

export const GetRequestById = async (setData, userId) => {
  try {
    await axios
      .post(`${url}/kiosk_details`, { user_id: userId })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  } catch (error) {
    console.log(error);
  }
};

export const GetFieldData = async (setData, dummy, id) => {
  try {
    await axios
      .post(
        `${url}/finvesta_user_product_details`,
        {
          data_required: dummy,
          user_id: id
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization:`Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        setData(res.data);
      });
  } catch (error) {
    console.log(error);
  }
};

export const ProvideDsVideoKycApproval = async (postData, setIsLoading, handleAlertOpen, setAlertMessage, setAlertType, handleGet) => {
  try {
    setIsLoading(true);
    let usertype = sessionStorage.getItem('UserType');
    await axios
      .post(`${url2}/${usertype}/ds/approve`, postData, {
        headers: {
          'Content-Type': 'application/json',
          Authorization:`Bearer ${sessionStorage.getItem('token')}`,
          'user-id': postData
        }
      })

      .then((res) => {
        setAlertMessage(res.data.message);
        setAlertType('success');
        handleAlertOpen();
        handleGet();
        setIsLoading(false);
      });
  } catch (error) {
    setAlertMessage(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong');
    setAlertType('error');
    handleAlertOpen();
    setIsLoading(false);
    // console.log(error);
    TokenLogout(error);
  }
};

export const ProvideGmApproval = async (
  data,
  setData,
  handleClose,
  setAlertMessage,
  handleAlertOpen,
  setAlertType,
  setDisableButtons,
  handleSelectedClose,
  setIsloading,
  handleRejectClose
) => {
  // console.log("Data api ", data);
  try {
    setDisableButtons(true);
    let usertype = sessionStorage.getItem('UserType');
    if (usertype === 'gm') {
      await axios
        .post(`${url2}/ds/${usertype}/update`, data, {
          headers: {
            'Content-Type': 'application/json',
                    Authorization:`Bearer ${sessionStorage.getItem('token')}`

          }
        })
        .then((response) => {
          setAlertMessage(response.data.message);
          setAlertType('success');
          handleAlertOpen();
          setDisableButtons(false);
          handleRejectClose();
          setTimeout(() => {
            handleClose();
            handleSelectedClose();
            // window.location.reload();
          }, 1500);
          GetAllRequest(0, setData, setIsloading);
        });
    }
  } catch (error) {
    setAlertMessage(
      error.response.data.Error ? error.response.data.Error : error.response.data.error ? error.response.data.error : 'Something Went Wrong'
    );
    setAlertType('error');
    handleAlertOpen();
    setDisableButtons(false);
    TokenLogout(error);
  }
};

export const ProvideNonFiApproval = async (
  data,
  setData,
  handleClose,
  setAlertMessage,
  handleAlertOpen,
  setAlertType,
  setDisableButtons,
  handleSelectedClose,
  setIsloading,
  handleRejectClose
) => {
  // console.log("Data api ", data);
  try {
    setDisableButtons(true);
    let usertype = sessionStorage.getItem('UserType');
    if (usertype === 'prod_own' || usertype === 'non_fi_head') {
      await axios
        .post(`${url2}/ds/non_fi/update`, data, {
          headers: {
            'Content-Type': 'application/json',
                    Authorization:`Bearer ${sessionStorage.getItem('token')}`

          }
        })
        .then((response) => {
          setAlertMessage(response.data.message);
          setAlertType('success');
          handleAlertOpen();
          setDisableButtons(false);
          handleRejectClose();
          setTimeout(() => {
            handleClose();
            handleSelectedClose();
            // window.location.reload();
          }, 1500);
          GetAllRequest(0, setData, setIsloading);
        });
    }
  } catch (error) {
    setAlertMessage(
      error.response.data.Error ? error.response.data.Error : error.response.data.error ? error.response.data.error : 'Something Went Wrong'
    );
    setAlertType('error');
    handleAlertOpen();
    setDisableButtons(false);
    TokenLogout(error);
  }
};

export const ProvideApproval = async (
  postData,
  data,
  setData,
  handleClose,
  setAlertMessage,
  handleAlertOpen,
  setAlertType,
  setDisableButtons,
  handleSelectedClose,
  setIsloading,
  handleRejectClose,
  setDialogOpen,
  setRemarkOpen
) => {
  // console.log("PostData api ", postData);
  setIsloading(true);
  try {
    setDisableButtons(true);
    let usertype = sessionStorage.getItem('UserType');
    const keyBody =
      usertype === 'ops'
        ? 'ops_ds_status'
        : usertype === 'sh'
        ? 'sh_ds_status'
        : usertype === 'rm'
        ? 'rm_ds_status'
        : usertype === 'cso'
        ? 'cso_ds_status'
        : '';
    if (usertype === 'ops' || usertype === 'sh' || usertype === 'rm' || usertype === 'cso') {
      await axios
        .post(
          `${url2}/ds/status/update`,
          {
            user_id: postData,
            [keyBody]: data
          },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization:`Bearer ${sessionStorage.getItem('token')}`,
              // 'user-id': postData
            }
          }
        )
        .then((response) => {
          setAlertMessage(response.data.message);
          setAlertType('success');
          handleAlertOpen();
          setDisableButtons(false);
          handleRejectClose();
          setIsloading(false);
          setTimeout(() => {
            handleClose();
            setDialogOpen(false);
            setRemarkOpen(false);
            handleSelectedClose();
          }, 1500);
          GetAllRequest(0, setData, setIsloading);
        })
        .catch((error) => {
          setAlertMessage(error.response ? error.response.data.error : 'Something went wrong');
          setAlertType('error');
          handleAlertOpen();
          setDisableButtons(false);
          setIsloading(false);
          setRemarkOpen(false);
          TokenLogout(error);
        });
    }
  } catch (error) {
    console.log(error);
    setAlertMessage(error.response ? error.response.data.error : 'Something went wrong');
    setAlertType('error');
    handleAlertOpen();
    setDisableButtons(false);
    setIsloading(false);
    setRemarkOpen(false);
    TokenLogout(error);
  }
};

export const ProvideReject = async (
  postData,
  setData,
  handleClose,
  setAlertMessage,
  handleAlertOpen,
  setAlertType,
  setDisableButtons,
  handleSelectedClose,
  setIsloading,
  handleRejectClose
) => {
  // console.log("PostData api ", postData);
  try {
    setDisableButtons(true);
    if (sessionStorage.getItem('UserType') === 'ops') {
      await axios
        .post(`${url2}/ops/reject/user`, postData, {
          headers: {
            'Content-Type': 'application/json',
             Authorization:`Bearer ${sessionStorage.getItem('token')}`,
            'user-id': postData
          }
        })
        .then((response) => {
          setAlertMessage(response.data.message);
          setAlertType('success');
          handleAlertOpen();
          setDisableButtons(false);
          handleRejectClose();
          setTimeout(() => {
            handleClose();
            handleSelectedClose();
          }, 1500);
        });

      GetAllRequest(0, setData, setIsloading);
    }
  } catch (error) {
    console.log(error);
    setAlertMessage(error.message);
    setAlertType('error');
    handleAlertOpen();
    setDisableButtons(false);
  }
};

export const GetUserData = async (iserId, setData) => {
  // let usertype=sessionStorage.getItem('UserType');
  try {
    await axios
      .post(
        `${url2}/ops/ds/details`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
             Authorization:`Bearer ${sessionStorage.getItem('token')}`,
            'user-id': iserId
          }
        }
      )
      .then((res) => {
        setData(res.data);
      });
  } catch (error) {
    // console.log(error);
    TokenLogout(error);
  }
};

export const GetApprovalData = async (setData) => {
  let usertype = sessionStorage.getItem('UserType');
  try {
    await axios
      .post(
        `${url2}/${usertype}/ds/approved/list`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
                    Authorization:`Bearer ${sessionStorage.getItem('token')}`

          }
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        }
      });
  } catch (error) {
    // console.log(error);
    TokenLogout(error);
  }
};

export const GetRejectData = async (status,setData) => {
  let usertype = sessionStorage.getItem('UserType');
  const keyBody = usertype === 'ops' ? 'ops_ds_status' : usertype === 'sh' ? 'sh_ds_status' : usertype === 'rm' ? 'sh_ds_status' : usertype === 'rm' ?'rm_ds_status': usertype === 'prod_own' ? 'prod_own_ds_status' : usertype === 'non_fi_head' ? 'non_fi_head_ds_status' :'';

  try {
    await axios
      .post(
        `${url2}/ds/gm/updated/list`,
        {[keyBody]:status},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization:`Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        if (res.status === 200) {
          TokenLogout(error);
          setData(res.data);
        }
      });
  } catch (error) {
    TokenLogout(error);
    console.log(error);
  }
};

// export const GetDsFile=async(url,setData)=>{
//     try {

//     } catch (error) {

//     }
// }

export const OpsListApi = async (page, setData, setIsloading, setTotalCount) => {
  setIsloading(true);
  try {
    await axios
      .post(
        `${url2}/ds/pending/list?page=${page}`,
        {},
        {
          headers: {
            Authorization:`Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          setData(res.data.ds_data);
          setTotalCount(res.data);
          setIsloading(false);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        setIsloading(false);
        setData(null);
        console.log(error);
      });
  } catch (error) {
    TokenLogout(error);
    setIsloading(false);
    setData(null);
    console.log(error);
  }
};

export const opsApprovedList = async (page, limit, status, setData, setIsloading) => {
  setIsloading(true);
  try {
    await axios
      .post(
        `${url2}/ds/status/updated/list?page=${page}&limit=${limit}`,
        { ds_status: status },
        {
          headers: {
              Authorization:`Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          setData(res.data);
          setIsloading(false);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        setIsloading(false);
        setData(null);
        console.log(error);
      });
  } catch (error) {
    TokenLogout(error);
    setIsloading(false);
    setData(null);
    console.log(error);
  }
};
